const C = require("../constants");

const openModalExpense = modal => {
    return {
        type: C.EXPENSE_MODAL,
        modal
    }
};

export {openModalExpense};


// WEBPACK FOOTER //
// ./src/actions/ModalExpenseActions.js